import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { services } from '../data/siteData';

function Services() {
  return (
    <section className="section services" id="services">
      <div className="section-heading">
        <div>
          <span className="section-label">What we do for our clients</span>
          <h2>
            Technology that
            <br />
            fits your needs.
          </h2>
        </div>
        <p>
          We help clients solve complex problems using AI through practical
          automation, custom software, and expert technology guidance.
        </p>
      </div>

      <div className="service-grid">
        {services.map((service, index) => (
          <motion.article
            className="service-card"
            key={service.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ delay: index * 0.06, duration: 0.45 }}
          >
            <div className="service-top">
              <span className="service-icon" aria-hidden="true">
                <SafeIcon icon={service.icon} />
              </span>
              <span className="service-number">{service.number}</span>
            </div>
            <h3>{service.title}</h3>
            <p>{service.text}</p>
          </motion.article>
        ))}
      </div>
    </section>
  );
}

export default Services;